import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Tooltip } from 'src/presentation/components/agent_desktop_components';

export const Message = styled.p`
  line-height: 162%;
  margin: 0;
  text-align: center;
`;

const AdminTooltip = props => {
  const { windowHeight, windowWidth } = useWindowSize();
  let bounds = props.pound;
  if (props.boundByWindow) {
    bounds = {
      bottom: windowHeight - 68,
      left: 8,
      right: windowWidth - 8,
      top: 68,
    };
  }

  return <Tooltip {...props} bounds={bounds} />;
};

AdminTooltip.defaultProps = {
  boundByWindow: true,
};

function getSize() {
  return {
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
  };
}

function useWindowSize() {
  const [{ windowHeight, windowWidth }, setWindowDimensions] = useState(getSize);

  const onWindowResize = useCallback(() => setWindowDimensions(getSize()), []);
  useEffect(() => {
    window.addEventListener('resize', onWindowResize);
    return () => window.removeEventListener('resize', onWindowResize);
  }, [onWindowResize]);

  return { windowHeight, windowWidth };
}

export default AdminTooltip;
